/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import "./App.css";
import "./Home.css";

import React, {useEffect } from "react";
import { Route, Routes} from "react-router-dom";
import Home from "./Pages/Home/Homescreen";
import Login from "./Pages/Home/Login";
import AboutMe from "./Pages/Home/AboutMe";
import Signin from "./Pages/Home/Signin";
import { getSocket } from "./socket"; // ✅ import singleton socket

// Main pages
import AdminDashboard from "./Pages/Dashboard/AdminDashboard"
import StudentDashboard from "./Pages/Dashboard/StudentDashboard"
import TutorDashboard from "./Pages/Dashboard/TutorDashboard"
import UserManagement from "./Pages/Dashboard/UserManagement"
import Contacts from "./Pages/Dashboard/Contacts"
import Password from "./Pages/Dashboard/Password"
import ResetPassword from "./Pages/Dashboard/ResetPassword"
import Allocation from "./Pages/Dashboard/Allocation"
import Scheduler from "./Pages/Dashboard/Scheduler"
import ProtectedRoute from "./Pages/Dashboard/ProtectedRoute";
import Reports from "./Pages/Dashboard/Reports";

const App = () => {
  useEffect(() => {
    const socket = getSocket();

    // Add listeners only once
    const handleChat = (data) => console.log("Chat message:", data);
    const handleFile = (data) => console.log("File message:", data);

    socket.on("showChatMessage", handleChat);
    socket.on("showFileMessage", handleFile);

    return () => {
      socket.off("showChatMessage", handleChat);
      socket.off("showFileMessage", handleFile);
    };
    }, []);
  return (
    <div className="App">       
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/Login" element={<Login />}></Route>
            <Route path="/AboutMe" element={<AboutMe />}></Route>
            <Route path="/Signin" element={<Signin />}></Route>
            {/* Protected routes */}
            <Route path="/AdminDashboard" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>}/>
            <Route path="/UserManagement" element={<ProtectedRoute><UserManagement /></ProtectedRoute>}/>
            <Route path="/Contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>}/>
            <Route path="/Password" element={<ProtectedRoute><Password /></ProtectedRoute>}/>
            <Route path="/ResetPassword" element={<ProtectedRoute><ResetPassword /></ProtectedRoute>}/>
            <Route path="/Allocation" element={<ProtectedRoute><Allocation /></ProtectedRoute>}/>
            <Route path="/Scheduler" element={<ProtectedRoute><Scheduler /></ProtectedRoute>}/>
            <Route path="/StudentDashboard" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>}/>
            <Route path="/TutorDashboard" element={<ProtectedRoute><TutorDashboard /></ProtectedRoute>}/>
            <Route path="/Reports" element={<ProtectedRoute><Reports /></ProtectedRoute>}/>
            {/* Fallback route */}
            <Route path="*" element={<Signin />} />
          </Routes>
    </div>
  );
};

export default App;
